import { render, staticRenderFns } from "./CrTwitchDestination.vue?vue&type=template&id=8c6b9d26&"
import script from "./CrTwitchDestination.vue?vue&type=script&lang=js&"
export * from "./CrTwitchDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports